import { PerfectiveVerb } from '../../types'

const спиздить: PerfectiveVerb = {
  type: 'perfective verb',
  infinitive: 'спиздить',
  imperativePluralSecondPerson: 'спиздите',
  imperativeSingularSecondPerson: 'спизди',
  indicativeFuturePluralFirstPerson: 'спиздим',
  indicativeFuturePluralSecondPerson: 'спиздите',
  indicativeFuturePluralThirdPerson: 'спиздят',
  indicativeFutureSingularFirstPerson: 'спизжу',
  indicativeFutureSingularSecondPerson: 'спиздишь',
  indicativeFutureSingularThirdPerson: 'спиздит',
  indicativePastPlural: 'спиздили',
  indicativePastSingularFeminine: 'спиздила',
  indicativePastSingularMasculine: 'спиздил',
  indicativePastSingularNeuter: 'спиздило',
}

export default спиздить
